module.exports = __webpack_public_path__ + "img/icon-home.light.1ecc5d8a.svg";